<template>
  <b-container fluid id="events" class="page">
    <div
      class="title d-flex justify-content-between align-items-center flex-wrap"
    >
      <h1>{{ page.title }}</h1>
      <router-link class="link" to="/demo-builder"
        ><b-button variant="primary"> Create a demo </b-button></router-link
      >
    </div>

    <software
      v-for="entry in software"
      :key="entry.title"
      :softwareData="entry"
      class="software-item-separator"
    />
    <p v-if="software.length === 0">No software published yet.</p>

    <b-button
      class="load-more-button"
      variant="primary"
      v-if="next_page_url !== null"
      @click="loadMoreSoftware"
    >
      Load More Software
    </b-button>

    <loading class="loading-animation" v-if="loadingMoreSoftware"></loading>
  </b-container>
</template>

<script>
import Software from "@/components/Software.vue";
import Loading from "@/components/Loading.vue";
import { getPaginationData, getByFullURL } from "@/api";

export default {
  name: "SoftwareIndex",
  created() {
    console.log(this.page);
    this.requestSoftware();
  },
  components: {
    Software,
    Loading,
  },
  data() {
    return {
      software: [],
      next_page_url: null,
      loadingMoreSoftware: false,
    };
  },
  methods: {
    loadMoreSoftware() {
      this.loadingMoreSoftware = true;
      getByFullURL(this.next_page_url).then((response) => {
        this.software = [...this.software.concat(response.data.results)];
        this.next_page_url = response.data.next;
        this.loadingMoreSoftware = false;
      });
    },
    requestSoftware() {
      getPaginationData("software", { breast: 1 }).then((response) => {
        this.software = response.data.results;
        this.next_page_url = response.data.next;
        console.log(response.data);
      });
    },
  },
  props: ["page"],
};
</script>

<style lang="scss">
.software-item-separator {
  margin-top: 4em;
}

.load-more-button {
  display: block !important;
  margin-top: 8em !important;
  margin-left: auto !important;
  margin-right: auto !important;
}
</style>
